// NIGHT-DIRECTSTAFF-2026-10-25c §1: Needs a human -- each item's age in BUSINESS hours (Mon–Fri 09:00–17:00 Eastern, the agents'
// hand-off SLA clock, NIGHT-AGENTS-2026-10-25c §3), amber past 2 business hours, red past 24 hours on the clock; Snooze (1 hour /
// tomorrow 9 AM / a time you pick) hides it until then, with Undo; the badge counts only what is not snoozed.
//   Where a snooze lives: the CRM's shared settings row "crm.needsSnooze.v1" ({ <row key>: { until, by } }, every staff account
//   sees the same) -- works today, nothing to apply -- AND, for the agents' SLA reminder, agent_notifications.snoozed_until /
//   snoozed_by on the item's open alerts (2026-10-26-needs-snooze.sql, filed; until the hub applies it that write is skipped and
//   the agents' reminder still fires).
export const SNOOZE_KEY = 'crm.needsSnooze.v1';
const TZ = 'America/New_York';
const H = 36e5;

/** The UTC instant of a wall-clock time in New York on a given ET calendar day ('YYYY-MM-DD', hour) */
function etInstant(day, hour) {
  for (const off of [-4, -5]) {
    const x = Date.parse(`${day}T${String(hour).padStart(2, '0')}:00:00${off === -4 ? '-04:00' : '-05:00'}`);
    const back = new Date(x).toLocaleString('en-US', { timeZone: TZ, hour: '2-digit', hourCycle: 'h23' });
    if (Number(back) === hour) return x;
  }
  return Date.parse(`${day}T${String(hour).padStart(2, '0')}:00:00-05:00`);
}
const etDay = (ms) => new Date(ms).toLocaleDateString('en-CA', { timeZone: TZ });
const etWeekday = (day) => new Date(`${day}T12:00:00Z`).getUTCDay();          // 0 Sun .. 6 Sat (the ET calendar day)
const nextDay = (day) => new Date(Date.parse(`${day}T12:00:00Z`) + 864e5).toISOString().slice(0, 10);

/** Business hours between two instants (Mon–Fri 09:00–17:00 Eastern), as a fractional number of hours */
export function businessHours(fromMs, toMs) {
  if (!(toMs > fromMs)) return 0;
  let total = 0;
  let d = etDay(fromMs);
  const last = etDay(toMs);
  for (let guard = 0; guard < 400; guard += 1) {
    const wd = etWeekday(d);
    if (wd >= 1 && wd <= 5) {
      const a = Math.max(fromMs, etInstant(d, 9)); const b = Math.min(toMs, etInstant(d, 17));
      if (b > a) total += (b - a) / H;
    }
    if (d === last) break;
    d = nextDay(d);
  }
  return total;
}
/** "under 1 business hour" | "3 business hours" | "2 business days" (a business day = 8 hours) */
export function ageText(bh) {
  if (bh < 1) return 'under 1 business hour';
  if (bh < 16) return `${Math.floor(bh)} business hour${Math.floor(bh) === 1 ? '' : 's'}`;
  return `${Math.floor(bh / 8)} business days`;
}
/** 'red' past 24 h on the clock, 'amber' past 2 business hours, '' otherwise */
export const ageTone = (fromMs, now = Date.now()) => (now - fromMs >= 24 * H ? 'red' : businessHours(fromMs, now) >= 2 ? 'amber' : '');
export const TONES = { red: { color: '#b91c1c', bg: '#fef2f2' }, amber: { color: '#92400e', bg: '#fffbeb' }, '': { color: '#475569', bg: '#f1f5f9' } };
// NIGHT-DIRECTSTAFF-2026-10-28 §2: the clock -- an item's age in hours ("49 h") and OVERDUE past 24 h (red past 48 h), the agents'
// [OVERDUE] line. Business hours stay the colour rule above; the clock is what the badge and the counts use.
export const OVERDUE_H = 24;
export const hoursOld = (fromMs, now = Date.now()) => (now > fromMs ? Math.floor((now - fromMs) / H) : 0);
/** 'red' at 48 h or more, 'amber' at 24 h or more, '' under 24 h */
export const overdueLevel = (fromMs, now = Date.now()) => { const h = hoursOld(fromMs, now); return h >= 2 * OVERDUE_H ? 'red' : h >= OVERDUE_H ? 'amber' : ''; };
/** how many of these times are overdue (unparseable ones are not) */
export const overdueCount = (isoList, now = Date.now()) => (isoList || []).filter((x) => { const t = Date.parse(x || ''); return !Number.isNaN(t) && overdueLevel(t, now) !== ''; }).length;
/** "Needs a human · 13 · 4 overdue" (no overdue -> "Needs a human · 13") */
export const needsTitle = (n, over) => `Needs a human · ${n}${over ? ` · ${over} overdue` : ''}`;

/** Snooze choices from now: in 1 hour, tomorrow 9 AM Eastern */
export function snoozeChoices(now = Date.now()) {
  const tomorrow = nextDay(etDay(now));
  return [['1h', 'For 1 hour', new Date(now + H).toISOString()], ['tomorrow', 'Until tomorrow 9 AM', new Date(etInstant(tomorrow, 9)).toISOString()]];
}
/** a stored snooze map -> Map(key -> until ISO) of the ones still in force */
export function activeSnoozes(raw, now = Date.now()) {
  let v = raw;
  try { if (typeof raw === 'string') v = JSON.parse(raw); } catch (e) { v = {}; }
  const out = new Map();
  for (const [k, x] of Object.entries(v && typeof v === 'object' ? v : {})) {
    const until = Date.parse((x && x.until) || '');
    if (until > now) out.set(k, new Date(until).toISOString());
  }
  return out;
}
/** the stored map with one key set (until) or cleared (null); expired entries dropped */
export function withSnooze(raw, key, until, by = '', now = Date.now()) {
  const cur = Object.fromEntries([...activeSnoozes(raw, now)].map(([k, u]) => [k, { until: u }]));
  let old = {}; try { old = typeof raw === 'string' ? JSON.parse(raw) : (raw || {}); } catch (e) { old = {}; }
  for (const k of Object.keys(cur)) if (old[k] && old[k].by) cur[k].by = old[k].by;
  if (until) cur[key] = { until: new Date(until).toISOString(), ...(by ? { by } : {}) }; else delete cur[key];
  return cur;
}
/** "Snoozed until Tue 9:00 AM" */
export const untilText = (iso) => `Snoozed until ${new Date(iso).toLocaleString('en-US', { weekday: 'short', hour: 'numeric', minute: '2-digit' })}`;
